import { Injectable } from '@angular/core';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../external-interfaces/notification-provider.service';
import StateModel from '../models/state.model';
import SlotModel from '../models/slot.model';
import { CustomerDetailsModel } from '../models/customer-details.model';

@Injectable()
export default class SlotStateService {

  private isCustomerDataPresent = false;
  private slotStates: any = {};

  constructor(
    private notificationProvider: NotificationProviderService
  ) {
    this.notificationProvider.subscribe(
      NotificationProviderTypeEnum.CUSTOMER_DETAILS,
      (customerDetails: CustomerDetailsModel) => {
        this.isCustomerDataPresent = !!customerDetails;
      });
  }

  public restoreSlotState(bundleNumber: number) {
    const slotState = this.slotStates[bundleNumber];

    slotState.tempState = slotState.tempState || {};

    Object.keys(slotState.originalState).forEach(key => slotState.tempState[key] = slotState.originalState[key]);
  }

  public setOriginalState(slot: SlotModel) {

    //if slotStates[_slot.bundlNumber] == null set an empty object
    const slotState = this.slotStates[slot.bundleNumber] = this.slotStates[slot.bundleNumber] || {};

    slotState.originalState = new StateModel(slot, this.isCustomerDataPresent);
  }

  public getTempState(bundleNumber: number) {
    const slotState = this.slotStates[bundleNumber];

    if (!slotState.tempState) {
      this.restoreSlotState(bundleNumber);
    }

    slotState.tempState.msisdn = slotState.originalState.msisdn;

    return slotState.tempState;
  }

  public getOriginalState(bundleNumber: number) {
    const slotState = this.slotStates[bundleNumber];

    return slotState.originalState;
  }

  public dropTempState(bundleNumber: number) {
    this.slotStates[bundleNumber].tempState = null;
  }

  public isInProgress(tempState: any) {
    return tempState && (tempState.MNP_EDIT_STATE || tempState.RETENTION_EDIT_STATE || tempState.UPSELL_EDIT_STATE || tempState.PREPAID_2_POSTPAID_EDIT_STATE);
  }

  public isValidByBundleNumber(bundleNumber: number) {
    const tempState = this.getTempState(bundleNumber);

    return !this.isInProgress(tempState);
  }

}
